document.addEventListener('DOMContentLoaded', () => {
    const app = document.getElementById('investorAdvisorApp');
    if (!app) {
        return;
    }

    const steps = app.querySelectorAll('[data-advisor-step]');
    const header = document.querySelector('[data-advisor-header]');
    const progress = app.querySelector('[data-advisor-progress]');
    const stepsContainer = app.querySelector('[data-advisor-steps]');
    const resultPanels = app.querySelectorAll('[data-advisor-result]');
    const inner = app.closest('.investor-advisor__inner');
    const progressLabel = app.querySelector('[data-advisor-progress-label]');
    const progressFill = app.querySelector('[data-advisor-progress-fill]');
    const contactUrl = app.dataset.advisorContactUrl || '/kontakt';
    const totalSteps = steps.length;
    const PROGRESS_MS = 600;
    const FADE_MS = 250;

    let isTransitioning = false;
    let currentStep = 1;
    const answers = {
        step1: null,
        step2: null,
        step3: null,
    };

    const getCard = (step) => app.querySelector(`[data-advisor-step="${step}"]`);

    const wait = (ms) => new Promise((resolve) => {
        window.setTimeout(resolve, ms);
    });

    const waitForTransition = (element, propertyName, maxMs) => new Promise((resolve) => {
        let done = false;

        const finish = () => {
            if (done) {
                return;
            }

            done = true;
            element.removeEventListener('transitionend', onEnd);
            resolve();
        };

        const onEnd = (event) => {
            if (event.target !== element || event.propertyName !== propertyName) {
                return;
            }

            finish();
        };

        element.addEventListener('transitionend', onEnd);
        window.setTimeout(finish, maxMs);
    });

    const setProgress = (step) => {
        if (progressLabel) {
            progressLabel.textContent = `Krok ${step} z ${totalSteps}`;
        }

        if (progressFill) {
            progressFill.style.width = `${((step - 1) / totalSteps) * 100}%`;
        }
    };

    const resolveResultKey = () => {
        if (answers.step1 === 'radiator') {
            return 'trv_heads';
        }

        if (answers.step1 === 'mixed') {
            return 'zonal_system';
        }

        if (answers.step1 === 'floor') {
            if (answers.step2 === 'central_thermostat') {
                if (answers.step3 === 'room_temperatures') {
                    return 'smart_thermostat';
                }

                return 'main_regulator';
            }

            if (answers.step2 === 'zone_thermostats') {
                return 'smart_thermostat';
            }

            return 'smart_thermostat';
        }

        return 'smart_thermostat';
    };

    const redirectToContact = () => {
        window.location.href = contactUrl;
    };

    const showStepInstant = (step) => {
        steps.forEach((element) => {
            const elementStep = Number.parseInt(element.dataset.advisorStep, 10);
            element.hidden = elementStep !== step;
            element.classList.remove('investor-advisor__card--leaving', 'investor-advisor__card--entering');
        });

        setProgress(step);
        currentStep = step;
    };

    const advanceToStep = async (nextStep) => {
        if (isTransitioning || nextStep > totalSteps || nextStep <= currentStep) {
            return;
        }

        isTransitioning = true;

        const currentCard = getCard(currentStep);
        const nextCard = getCard(nextStep);

        setProgress(nextStep);

        const progressDone = progressFill
            ? waitForTransition(progressFill, 'width', PROGRESS_MS + 50)
            : wait(PROGRESS_MS);

        const cardDone = (async () => {
            await wait(PROGRESS_MS / 2);

            if (currentCard) {
                currentCard.classList.add('investor-advisor__card--leaving');
            }

            if (nextCard) {
                nextCard.hidden = false;
                nextCard.classList.add('investor-advisor__card--entering');
                nextCard.getBoundingClientRect();
                nextCard.classList.remove('investor-advisor__card--entering');
            }

            await wait(FADE_MS);

            if (currentCard) {
                currentCard.classList.remove('investor-advisor__card--leaving');
                currentCard.hidden = true;
            }
        })();

        await Promise.all([progressDone, cardDone]);

        currentStep = nextStep;
        isTransitioning = false;
    };

    const showResultView = async (resultKey, fromStep = currentStep) => {
        if (isTransitioning) {
            return;
        }

        const resultEl = app.querySelector(`[data-advisor-result][data-result-key="${resultKey}"]`);
        if (!resultEl) {
            return;
        }

        isTransitioning = true;

        const currentCard = getCard(fromStep);

        if (progressFill) {
            progressFill.style.width = '100%';
        }

        const progressDone = progressFill
            ? waitForTransition(progressFill, 'width', PROGRESS_MS + 50)
            : wait(PROGRESS_MS);

        await wait(PROGRESS_MS / 2);

        if (currentCard) {
            currentCard.classList.add('investor-advisor__card--leaving');
        }

        await wait(FADE_MS);

        if (currentCard) {
            currentCard.classList.remove('investor-advisor__card--leaving');
            currentCard.hidden = true;
        }

        await progressDone;

        if (stepsContainer) {
            stepsContainer.hidden = true;
        }

        if (progress) {
            progress.hidden = true;
        }

        if (header) {
            header.hidden = true;
        }

        inner?.classList.add('investor-advisor__inner--result');

        resultPanels.forEach((panel) => {
            panel.hidden = panel !== resultEl;
        });

        resultEl.hidden = false;
        resultEl.classList.add('investor-advisor__result--entering');
        resultEl.getBoundingClientRect();
        resultEl.classList.remove('investor-advisor__result--entering');

        await wait(FADE_MS);

        currentStep = 0;
        isTransitioning = false;
    };

    const restartWizard = () => {
        answers.step1 = null;
        answers.step2 = null;
        answers.step3 = null;

        resultPanels.forEach((panel) => {
            panel.hidden = true;
        });

        if (stepsContainer) {
            stepsContainer.hidden = false;
        }

        if (progress) {
            progress.hidden = false;
        }

        if (header) {
            header.hidden = false;
        }

        inner?.classList.remove('investor-advisor__inner--result');
        showStepInstant(1);
    };

    app.querySelectorAll('[data-advisor-option]').forEach((button) => {
        button.addEventListener('click', () => {
            if (isTransitioning) {
                return;
            }

            const step = Number.parseInt(
                button.closest('[data-advisor-step]')?.dataset.advisorStep || '0',
                10
            );
            const value = button.dataset.advisorValue;

            if (!step || !value) {
                return;
            }

            answers[`step${step}`] = value;

            if (value === 'unknown') {
                redirectToContact();
                return;
            }

            if (step < totalSteps) {
                advanceToStep(step + 1);
                return;
            }

            showResultView(resolveResultKey(), step);
        });
    });

    app.querySelectorAll('[data-advisor-restart]').forEach((button) => {
        button.addEventListener('click', restartWizard);
    });

    showStepInstant(1);
});
